
// constants.js
export const proxyUrl = 'https://swiggy-proxy.gagansalian04102005.workers.dev';

export const targetUrl = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.3730376&lng=74.7071271&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";


export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

// export const LOGO_URL="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRn7eaTHYrwbIDLDcu6q9UGxpa6vZ8aRoMzfQ&s";
// export const MENU_API="https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.3730376&lng=74.7071271&restaurantId=";

// export const SWIGGY_API="https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.3730376&lng=74.7071271&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"
// export const MENU_API = "https://cors.sh/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.3730376&lng=74.7071271&restaurantId=";

// export const SWIGGY_API = "https://cors.sh/https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.3730376&lng=74.7071271&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
export const SWIGGY_API = `${proxyUrl}/?url=${encodeURIComponent(targetUrl)}`;

export const MENU_API = (restaurantId) =>
  `${proxyUrl}/?url=${encodeURIComponent(
    `https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.3730376&lng=74.7071271&restaurantId=${restaurantId}`
  )}`;

